// Immutable helper to remove one annotation by UUID from local array state.
export const removeAnnotationByUuid = (annotations, annotationId) => {
  const index = annotations.findIndex(item => item.uuid === annotationId);
  if (index === -1) {
    return { removed: false, nextAnnotations: annotations };
  }
  const nextAnnotations = annotations.slice();
  nextAnnotations.splice(index, 1);
  return { removed: true, nextAnnotations };
};

// Immutable helper to upsert one annotation by UUID.
export const updateOrInsertAnnotationByUuid = (annotations, annotation) => {
  const index = annotations.findIndex(item => item.uuid === annotation.uuid);
  const nextAnnotations = annotations.slice();
  if (index === -1) {
    nextAnnotations.push(annotation);
  } else {
    nextAnnotations.splice(index, 1, annotation);
  }
  return { updated: index !== -1, nextAnnotations };
};
